import { render } from "./BoxingHistory.vue?vue&type=template&id=211a84b8&scoped=true"
import script from "./BoxingHistory.vue?vue&type=script&lang=js"
export * from "./BoxingHistory.vue?vue&type=script&lang=js"

import "./BoxingHistory.vue?vue&type=style&index=0&id=211a84b8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-211a84b8"]])

export default __exports__